import { sdk } from 'sdk';

const extensions = sdk.composableCommerce;

export const logout = async (): Promise<void> => {
  await extensions.account.logout();
};
